// Class: starling.utils.Align

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var Align = function(){}

// Meta

Align.__name__ = "starling.utils.Align";
Align.__isInterface__ = false;
Align.prototype = {
	
};
Align.prototype.__class__ = Align.prototype.constructor = $hxClasses["starling.utils.Align"] = Align;

// Init



// Statics

Align.isValid = function(align) {
	if(!(align == "left" || align == "right" || align == "center" || align == "top")) {
		return align == "bottom";
	} else {
		return true;
	}
}
Align.isValidHorizontal = function(align) {
	if(!(align == "left" || align == "center")) {
		return align == "right";
	} else {
		return true;
	}
}
Align.isValidVertical = function(align) {
	if(!(align == "top" || align == "center")) {
		return align == "bottom";
	} else {
		return true;
	}
}
Align.LEFT = "left"
Align.RIGHT = "right"
Align.TOP = "top"
Align.BOTTOM = "bottom"
Align.CENTER = "center"

// Export

exports.default = Align;